import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, Star } from 'lucide-react';
import { motion } from 'framer-motion';
export function PricingCards() {
  return <section className="py-6 md:py-10 px-4 max-w-5xl mx-auto" id="pricing" data-id="element-269">
      <FadeIn data-id="element-270">
        <h2 className="text-2xl md:text-4xl font-black text-center mb-5 md:mb-8 tracking-tight text-[#1a1611]" data-id="element-271">
          ELEGÍ TU MEGAPACK
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-4xl mx-auto items-stretch" data-id="element-272">
        {/* Card 1 */}
        <FadeIn delay={0.1} data-id="element-273">
          <div className="bg-white border border-[#e8dfd0] rounded-2xl p-5 md:p-7 h-full flex flex-col relative hover:border-[#c9a961]/50 transition-colors shadow-sm" data-id="element-274">
            <div className="mb-3" data-id="element-275">
              <h3 className="text-lg md:text-xl font-black text-[#1a1611] flex items-center gap-2 mb-1" data-id="element-276">
                <span className="text-xl md:text-2xl" data-id="element-277">📘</span> MEGAPACK BÁSICO
              </h3>
              <p className="text-[#6b5d4f] font-bold text-xs md:text-sm" data-id="element-278">
                6 Tomos + 6 Bonos
              </p>
            </div>

            <div className="mb-4 pb-4 border-b border-[#e8dfd0]" data-id="element-279">
              <div className="text-[#b91c1c] line-through text-sm font-bold" data-id="element-280">
                $95.000
              </div>
              <div className="text-3xl md:text-4xl font-black text-[#1a1611] flex items-baseline gap-2" data-id="element-281">
                $19.990{' '}
                <span className="text-base text-[#6b5d4f] font-bold" data-id="element-282">ARS</span>
              </div>
            </div>

            <ul className="space-y-2 mb-5 flex-grow" data-id="element-283">
              <li className="flex items-start gap-2.5" data-id="element-284">
                <div className="bg-[#c9a961]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-285">
                  <Check className="text-[#b8860b]" size={14} strokeWidth={3} data-id="element-286" />
                </div>
                <span className="text-sm text-[#1a1611] font-bold" data-id="element-287">
                  6 Tomos + 6 Bonos completos
                </span>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-288">
                <div className="bg-[#c9a961]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-289">
                  <Check className="text-[#b8860b]" size={14} strokeWidth={3} data-id="element-290" />
                </div>
                <span className="text-sm text-[#1a1611] font-bold" data-id="element-291">
                  Actualizaciones de por vida
                </span>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-292">
                <div className="bg-[#c9a961]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-293">
                  <Check className="text-[#b8860b]" size={14} strokeWidth={3} data-id="element-294" />
                </div>
                <span className="text-sm text-[#1a1611] font-bold" data-id="element-295">
                  Acceso inmediato por email
                </span>
              </li>
            </ul>

            <a href="https://tumanualdigital.com/cart/44175053488164:1" className="w-full block text-center py-3 px-4 rounded-xl font-black text-base bg-[#0a0a0a] hover:bg-[#1a1611] text-[#c9a961] transition-colors border border-[#1a1611]" data-id="element-296">
              → QUIERO MI MEGAPACK
            </a>
          </div>
        </FadeIn>

        {/* Card 2 - Featured */}
        <FadeIn delay={0.2} data-id="element-297">
          <div className="relative h-full" data-id="element-298">
            <div className="absolute inset-0 bg-[#c9a961]/20 blur-3xl rounded-[3rem] animate-pulse" data-id="element-299"></div>
            <div className="bg-white border-2 border-[#c9a961] rounded-2xl p-5 md:p-7 h-full flex flex-col relative shadow-[0_20px_50px_rgba(201,169,97,0.15)] z-10" data-id="element-300">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#c9a961] to-[#d4af37] text-[#0a0a0a] font-black px-4 py-1 rounded-full text-xs flex items-center gap-1.5 whitespace-nowrap shadow-md" data-id="element-301">
                <Star className="w-3.5 h-3.5" fill="currentColor" data-id="element-302" /> MÁS ELEGIDO
              </div>

              <div className="mb-3 mt-3" data-id="element-303">
                <h3 className="text-lg md:text-xl font-black text-[#1a1611] flex items-center gap-2 mb-1" data-id="element-304">
                  <span className="text-2xl" data-id="element-305">🏆</span> MEGAPACK + MÁQUINA IA
                </h3>
                <p className="text-[#b8860b] font-bold text-xs md:text-sm" data-id="element-306">
                  6 Tomos + 6 Bonos + Sistema de Gestión Completo
                </p>
              </div>

              <div className="mb-4 pb-4 border-b border-[#e8dfd0]" data-id="element-307">
                <div className="text-[#b91c1c] line-through text-sm font-bold" data-id="element-308">
                  $130.000
                </div>
                <div className="text-3xl md:text-4xl font-black text-[#1a1611] flex items-baseline gap-2" data-id="element-309">
                  $27.990{' '}
                  <span className="text-base text-[#6b5d4f] font-bold" data-id="element-310">
                    ARS
                  </span>
                </div>
              </div>

              <ul className="space-y-2 mb-5 flex-grow" data-id="element-311">
                <li className="flex items-start gap-2.5" data-id="element-312">
                  <div className="bg-[#c9a961]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-313">
                    <Check className="text-[#b8860b]" size={14} strokeWidth={3} data-id="element-314" />
                  </div>
                  <span className="text-sm text-[#1a1611] font-bold" data-id="element-315">
                    Todo lo del Megapack Básico
                  </span>
                </li>
                <li className="flex items-start gap-2.5 bg-[#c9a961]/10 p-2 rounded-xl border border-[#c9a961]/30 -mx-1" data-id="element-316">
                  <div className="bg-[#c9a961] p-1 rounded-full shrink-0 mt-0.5" data-id="element-317">
                    <Check className="text-[#0a0a0a]" size={14} strokeWidth={4} data-id="element-318" />
                  </div>
                  <span className="text-sm text-[#b8860b] font-black" data-id="element-319">
                    Máquina Administrativa IA (7 módulos)
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-320">
                  <div className="bg-[#c9a961]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-321">
                    <Check className="text-[#b8860b]" size={14} strokeWidth={3} data-id="element-322" />
                  </div>
                  <span className="text-sm text-[#1a1611] font-bold" data-id="element-323">
                    Dashboard Financiero + CRM en Notion
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-324">
                  <div className="bg-[#c9a961]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-325">
                    <Check className="text-[#b8860b]" size={14} strokeWidth={3} data-id="element-326" />
                  </div>
                  <span className="text-sm text-[#1a1611] font-bold" data-id="element-327">
                    Sistema Anti-Plante + Scripts difíciles
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-328">
                  <div className="bg-[#c9a961]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-329">
                    <Check className="text-[#b8860b]" size={14} strokeWidth={3} data-id="element-330" />
                  </div>
                  <span className="text-sm text-[#1a1611] font-bold" data-id="element-331">
                    Manual de Operaciones completo
                  </span>
                </li>
              </ul>

              <motion.a whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.97
            }} href="https://tumanualdigital.com/cart/44175081799716:1" className="w-full block text-center py-3 px-4 rounded-xl font-black text-base bg-[#c9a961] hover:bg-[#d4af37] text-[#0a0a0a] transition-colors shadow-[0_10px_30px_rgba(201,169,97,0.3)]" data-id="element-332">
                → QUIERO EL MEGAPACK + MÁQUINA
              </motion.a>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}